import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Elements } from 'react-stripe-elements';

import { addNotification } from 'actions/NotificationsActions';

import LeadWon from 'components/modals/LeadWon';
import LeadLost from 'components/modals/LeadLost';
import LeadDelete from 'components/modals/LeadDelete';
import LeadReopen from 'components/modals/LeadReopen';
import LeadChangeStage from 'components/modals/LeadChangeStage';
import LeadChangeTeam from 'components/modals/LeadChangeTeam';
import LeadChangePipeline from 'components/modals/LeadChangePipeline';
import LeadChangeStageChecker from 'components/modals/LeadChangeStageChecker';
//import LeadPriceNegotiation from 'components/modals/LeadPriceNegotiation';
import LeadQuoteNew from 'components/modals/LeadQuoteNew';
import LeadFilledQuestionnaireNew from 'components/modals/LeadFilledQuestionnaireNew';

import { ROLE_CRM_MASTER } from 'js/constants';
import may from 'js/security';
import { getOrderAuthorizationStatus, isAnyOrderItemOfType } from 'helpers/order';
import axios from 'axios';
import { isUserAbleToStartPipeline } from 'helpers/leads';

class LeadActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      showWon: false,
      showLost: false,
      showDelete: false,
      showReopen: false,
      showChangeStage: false,
      showChangeTeam: false,
      showChangePipeline: false,
      newStageId: null,
      showMoveLead: false,
      showPriceNegotiation: false,
      showQuoteNew: false,
      showFilledQuestionnaireNew: false,
      startingPipeline: false,
    };
  }

  showWon = () => {
    this.props.actionExecuted('showWon');
    this.setState({ showWon: true, isActive: true });
  };

  closeWon = () => {
    this.setState({ showWon: false, isActive: false });
  };

  showLost = () => {
    this.props.actionExecuted('showLost');
    this.setState({ showLost: true, isActive: true });
  };

  closeLost = () => {
    this.setState({ showLost: false, isActive: false });
  };

  showDelete = () => {
    this.props.actionExecuted('showDelete');
    this.setState({ showDelete: true, isActive: true });
  };

  closeDelete = () => {
    this.setState({ showDelete: false, isActive: false });
  };

  showReopen = () => {
    this.props.actionExecuted('showReopen');
    this.setState({ showReopen: true, isActive: true });
  };

  closeReopen = () => {
    this.setState({ showReopen: false, isActive: false });
  };

  showChangeStage = () => {
    this.props.actionExecuted('showChangeStage');
    this.setState({ showChangeStage: true, isActive: true });
  };

  closeChangeStage = () => {
    this.setState({ showChangeStage: false, isActive: false });
  };

  showChangeTeam = () => {
    this.props.actionExecuted('showChangeTeam');
    this.setState({ showChangeTeam: true, isActive: true });
  };

  closeChangeTeam = () => {
    this.setState({ showChangeTeam: false, isActive: false });
  };

  showChangePipeline = () => {
    this.props.actionExecuted('showChangePipeline');
    this.setState({ showChangePipeline: true, isActive: true });
  };

  closeChangePipeline = () => {
    this.setState({ showChangePipeline: false, isActive: false });
  };

  showMoveLead = newStageId => {
    this.props.actionExecuted('showMoveLead');
    this.setState({ showChangeStage: false, showMoveLead: true, newStageId, isActive: true });
  };

  closeMoveLead = () => {
    this.setState({ showMoveLead: false, newStageId: null, isActive: false });
  };

  showPriceNegotiation = () => {
    this.props.actionExecuted('showPriceNegotiation');
    this.setState({ showPriceNegotiation: true, isActive: true });
  };

  closePriceNegotiation = () => {
    this.setState({ showPriceNegotiation: false, isActive: false });
  };

  showQuoteNew = () => {
    this.props.actionExecuted('showQuoteNew');
    this.setState({ showQuoteNew: true, isActive: true });
  };

  closeQuoteNew = () => {
    this.setState({ showQuoteNew: false, isActive: false });
  };

  showFilledQuestionnaireNew = () => {
    this.props.actionExecuted('showFilledQuestionnaireNew');
    this.setState({ showFilledQuestionnaireNew: true, isActive: true });
  };

  closeFilledQuestionnaireNew = () => {
    this.setState({ showFilledQuestionnaireNew: false, isActive: false });
  };

  startPipeline = () => {
    this.props.actionExecuted('startPipeline');
    this.setState({startingPipeline: true});
    axios.get('/api/domainregistration/leads/' + this.props.lead.getId() + '/startpipeline.json')
      .then(response => {
        this.props.doNotify(1, this.props.intl.messages.pipeline_started);
      })
      .catch(error => {
        this.props.doNotify(0, error.message);
      })
      .then( () => {
        this.setState({startingPipeline: false});
      });
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatusLeadWon,
      formStatusLeadLost,
      formStatusLeadDelete,
      formStatusLeadReopen,
      formStatusChangeStage,
      formStatusChangePipeline,
      formStatusChangeTeam,
      formStatusQuoteNew,
      formStatusFilledQuestionnaireNew,
      doNotify,
    } = this.props;
    const { isActive } = this.state;

    if (prevProps.isActive || isActive) {
      // user has marked the lead won! yeah
      if (prevProps.formStatusLeadWon.pending && !formStatusLeadWon.pending && !formStatusLeadWon.hasError) {
        this.closeWon();
        doNotify(1, messages.lead_marked_won);
      }

      // user has marked the lead lost
      if (prevProps.formStatusLeadLost.pending && !formStatusLeadLost.pending && !formStatusLeadLost.hasError) {
        this.closeLost();
        doNotify(1, messages.lead_marked_lost);
      }

      // user has changed the stage
      if (
        prevProps.formStatusChangeStage.pending &&
        !formStatusChangeStage.pending &&
        !formStatusChangeStage.hasError
      ) {
        this.closeMoveLead();
        doNotify(1, messages.stage_changed);
      }

      // user has changed the pipeline of this lead
      if (
        prevProps.formStatusChangePipeline.pending &&
        !formStatusChangePipeline.pending &&
        !formStatusChangePipeline.hasError
      ) {
        this.closeChangePipeline();
        doNotify(1, messages.pipeline_changed);
      }

      // user requested assigning the lead to another team
      if (prevProps.formStatusChangeTeam.pending && !formStatusChangeTeam.pending && !formStatusChangeTeam.hasError) {
        this.closeChangeTeam();
        doNotify(1, messages.team_changed);
      }

      // user created new quote
      if (prevProps.formStatusQuoteNew.pending && !formStatusQuoteNew.pending && !formStatusQuoteNew.hasError) {
        this.closeQuoteNew();
        doNotify(1, messages.quote_saved);
      }

      // user created a rquest to fill out a questionnaire
      if (
        prevProps.formStatusFilledQuestionnaireNew.pending &&
        !formStatusFilledQuestionnaireNew.pending &&
        !formStatusFilledQuestionnaireNew.hasError
      ) {
        this.closeFilledQuestionnaireNew();
        doNotify(1, messages.request_to_fill_out_questionnaire_saved);
      }
    }
  };

  getActions = () => {
    const {
      intl: { messages },
      user,
      listItemComponent,
      lead,
    } = this.props;

    const actions = this.props.addActions.slice();
    const buttonProps = {
      block: true,
    };

    const isWon = lead.is_won || (lead.getIsWon && lead.getIsWon());
    const isLost = lead.is_lost || (lead.getIsLost && lead.getIsLost());
    const isDeleted = lead.is_deleted || (lead.getIsDeleted && lead.getIsDeleted());
    const isOrderLead = this.isOrderLead();

    if (isWon || isLost || isDeleted) {
      if (may(ROLE_CRM_MASTER, user.roles)) {
        // allow the CRM_MASTER role to reopen the lead
        const buttonAction = this.showReopen;
        const icon = 'fal fa-backward';
        return [
          listItemComponent === null ? (
            <Button {...buttonProps} onClick={buttonAction} key="reopen">
              {messages.reopen_lead}
            </Button>
          ) : (
            React.cloneElement(listItemComponent, {
              ...buttonProps,
              action: buttonAction,
              caption: messages.reopen_lead,
              icon,
              key: 'reopen',
            })
          ),
        ];
      }

      return [];
    }

    if (!isOrderLead) {
      const buttonAction = this.showChangeStage;
      const icon = 'fal fa-arrow-alt-square-right';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="change-stage">
            {messages.change_stage}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.change_stage,
            icon,
            key: 'change-stage',
          })
        )
      );
    }

    if (true) {
      const buttonAction = this.showWon;
      const icon = 'fal fa-smile-beam';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="message-new">
            {messages.won}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.won,
            icon,
            key: 'won',
          })
        )
      );
    }

    if (true) {
      const buttonAction = this.showChangeTeam;
      const icon = 'fal fa-user-friends';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="change-team">
            {messages.switch_team}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.switch_team,
            icon,
            key: 'change-team',
          })
        )
      );
    }

    if (!isAnyOrderItemOfType(lead.getOrders()[0] ?? null, 'DOMAIN_HOSTING')) {
      const buttonAction = this.showChangePipeline;
      const icon = 'fal fa-sitemap';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="change-pipeline">
            {messages.change_pipeline}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.change_pipeline,
            icon,
            key: 'change-pipeline',
          })
        )
      );
    } else if(getOrderAuthorizationStatus(lead.getOrders()[0] ?? null, 'aws_domain_hosting') && lead.getCurrentStageStatus() !== 'in_progress' && lead.getCurrentStage() !== '60910f4a211d371db868fd32' && isUserAbleToStartPipeline(lead.getId())) {
      const buttonAction = this.startPipeline;
      const startingPipeline = this.state.startingPipeline;
      const icon = 'fal fa-' + (startingPipeline ? 'gear fa-spin' : (lead.getCurrentStageStatus() === 'failed' ? 'repeat' : 'play'));
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} disabled={startingPipeline} onClick={buttonAction} key="change-pipeline">
            {messages.start_pipeline}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.start_pipeline,
            icon,
            key: 'change-pipeline',
            disabled: {startingPipeline}
          })
        )
      );
    }

    if (!isOrderLead) {
      const buttonAction = this.showLost;
      const icon = 'fal fa-frown-open';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="lost">
            {messages.lost}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.lost,
            icon,
            key: 'lost',
          })
        )
      );
    }

    if (may(ROLE_CRM_MASTER, user.roles)) {
      const buttonAction = this.showDelete;
      const icon = 'fal fa-trash-alt';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="delete">
            {messages.delete}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.delete,
            icon,
            key: 'delete',
          })
        )
      );
    }

    if (
      (lead && lead.processedData && lead.processedData.priceNegotiation && lead.processedData.priceNegotiation.id) ||
      lead.price_negotiation
    ) {
      const buttonAction = this.showPriceNegotiation;
      const icon = 'fal fa-comments-alt-dollar';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="price-proposal">
            {messages.price_negotiation}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.price_negotiation,
            icon,
            key: 'price-proposal',
          })
        )
      );
    }

    const isLeadHasProcessedDataItems = !!lead?.processedData?.items?.length;
    const isLeadHasProcessedDataOrders = !!lead?.processedData?.orders?.length;
    const isLeadHasItems = !!lead?.items?.length;
    const isLeadHasOrders = !!lead?.orders?.length;
    const isLeadHasTargetUsername = !!(lead?.target?.username || lead?.getTarget()?.getUsername());

    // distinct name of the Manual Quote Pipeline in at least one of languages
    // required to display a CreateQuote option
    const isManualQuotePipeline = lead
      ?.getPipeline()
      ?.getName()
      ?.some(item => item.name === 'Quote Pipeline');

    if (
      (isLeadHasProcessedDataItems ||
        isLeadHasProcessedDataOrders ||
        isLeadHasItems ||
        isLeadHasOrders ||
        isManualQuotePipeline) &&
      isLeadHasTargetUsername
    ) {
      const buttonAction = this.showQuoteNew;
      const icon = 'fal fa-file-invoice-dollar';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="quote-new">
            {messages.salesDoc.quote}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.salesDoc.quote,
            icon,
            key: 'quote-new',
          })
        )
      );
    }

    if (isLeadHasTargetUsername) {
      const buttonAction = this.showFilledQuestionnaireNew;
      const icon = 'fal fa-envelope-open-text';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={buttonAction} key="filled-questionnaire-new">
            {messages.questionnaire}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, {
            ...buttonProps,
            action: buttonAction,
            caption: messages.questionnaire,
            icon,
            key: 'filled-questionnaire-new',
          })
        )
      );
    }

    return actions;
  };

  isOrderLead = () => {
    const { lead } = this.props;

    const orders = lead.orders || (lead.getOrders && lead.getOrders());
    if (orders && orders.length) {
      const orderType = orders[0].type || (orders[0].getType && orders[0].getType());
      const orderLeadId = orders[0].lead_id || (orders[0].getLeadId && orders[0].getLeadId());

      return orderType !== 'car_rent' && (lead.id || lead.getId()) === orderLeadId;
    }

    return false;
  };

  render() {
    const { appIntl, lead, wrapperComponent } = this.props;
    const {
      showWon,
      showLost,
      showDelete,
      showReopen,
      showChangeStage,
      showChangeTeam,
      showChangePipeline,
      showMoveLead,
      showPriceNegotiation,
      showQuoteNew,
      showFilledQuestionnaireNew,
    } = this.state;

    const actions = this.getActions();
    const children = [];
    for (let i = 0; i < actions.length; i++) {
      children.push(actions[i]);
    }

    children.push(<LeadWon lead={lead} show={showWon} close={this.closeWon} key="won-popup" />);

    children.push(<LeadLost lead={lead} show={showLost} close={this.closeLost} key="lost-popup" />);

    children.push(<LeadDelete lead={lead} show={showDelete} close={this.closeDelete} key="delete-popup" />);

    children.push(<LeadReopen lead={lead} show={showReopen} close={this.closeReopen} key="reopen-popup" />);

    children.push(
      <LeadChangeStage
        lead={lead}
        show={showChangeStage}
        close={this.closeChangeStage}
        key="change-stage-popup"
        onSubmitParent={newStageId => this.showMoveLead(newStageId)}
      />
    );

    children.push(
      <LeadChangeTeam lead={lead} show={showChangeTeam} close={this.closeChangeTeam} key="change-team-popup" />
    );

    children.push(
      <LeadChangePipeline
        lead={lead}
        show={showChangePipeline}
        close={this.closeChangePipeline}
        key="change-pipeline-popup"
      />
    );

    children.push(
      <Elements locale={appIntl.locale} key={appIntl.locale}>
        <LeadChangeStageChecker
          lead={lead.processedData ? lead.processedData : lead}
          newStageId={this.state.newStageId}
          show={showMoveLead}
          close={this.closeMoveLead}
          key="change-stage-checker-popup"
        />
      </Elements>
    );

    children.push(<LeadQuoteNew lead={lead} show={showQuoteNew} close={this.closeQuoteNew} key="quote-new-popup" />);

    children.push(
      <LeadFilledQuestionnaireNew
        lead={lead}
        show={showFilledQuestionnaireNew}
        close={this.closeFilledQuestionnaireNew}
        key="filled-questionnaire-new-popup"
      />
    );

    if (wrapperComponent === null) {
      return children;
    }

    return React.cloneElement(wrapperComponent, {}, children);
  }
}
LeadActions.defaultProps = {
  wrapperComponent: <div />,
  listItemComponent: null,
  actionExecuted: () => { },
  addActions: [],
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    formStatusLeadWon: state.formStatus.leadWon,
    formStatusLeadLost: state.formStatus.leadLost,
    formStatusLeadDelete: state.formStatus.leadDelete,
    formStatusLeadReopen: state.formStatus.leadReopen,
    formStatusChangeStage: state.formStatus.leadChangeStage,
    formStatusChangePipeline: state.formStatus.leadChangePipeline,
    formStatusChangeTeam: state.formStatus.leadChangeTeam,
    formStatusQuoteNew: state.formStatus.quoteNew,
    formStatusFilledQuestionnaireNew: state.formStatus.filledQuestionnaireNew,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
  )(LeadActions),
  { forwardRef: true }
);
